import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { Customer } from '../../__generated__/graphql';
import { useEffect } from 'react';
import { pusherSubscribeObject } from '../../Common/utils/pusher';

const GET_CUSTOMER = graphql(`
  query useDoctorCustomerLookup($id: ID) {
    getCustomerBrand(id: $id) {
      __typename
      id
      name
      given
      brand
      doctor
      surname
      dob
      completedProfile
      prescriptionReady
      completedConsent
      email
      mobile
      gender
      address
      suburb
      state
      postcode
      medicalhistory
      medications
      medicarenumber
      medicareref
      medicareexp
      hearaboutus
      allergies
      street
      kyc
      internal
      kycType
      kycAddress
      kycName
    }
  }
`);

export const useDoctorCustomerLookup = (customerID: string) => {
  const { loading, data, refetch } = useQuery(GET_CUSTOMER, {
    fetchPolicy: 'cache-and-network',
    variables: {
      id: customerID,
    },
  });

  useEffect(() => {
    const { unsubscribe } = pusherSubscribeObject(customerID ?? '', 'customer', () => refetch());

    return () => {
      unsubscribe();
    };
  }, [customerID]);

  const customerHasMedicare =
    data?.getCustomerBrand?.medicarenumber &&
    data?.getCustomerBrand?.medicarenumber?.length > 2 &&
    data?.getCustomerBrand?.medicareref &&
    data?.getCustomerBrand?.medicareref?.length > 0;

  return {
    customer: data?.getCustomerBrand as Customer,
    loading,
    customerHasMedicare,
  };
};
